import React from 'react';

const sections = [
  {
    heading: '제1조 (목적)',
    body: [
      `이 약관은 오잉랩(브랜드명 "코레디", 이하 "회사")이 제공하는 서비스를 기업회원이 이용함에 있어 "회사"와 "회원" 사이의 이용 조건, 절차, 권리와 의무, 책임 사항 및 그 밖에 필요한 사항을 정하는 것을 목적으로 합니다.`,
    ],
  },
  {
    heading: '제2조 (용어의 정의)',
    body: [
      `이 약관에서 사용하는 용어의 뜻은 다음과 같습니다.`,
      ``,
      <>
        1. &quot;사이트&quot;란 &quot;회사&quot;가 &quot;회원&quot;에게 서비스를
        제공하기 위하여 정보통신설비를 이용하여 마련한 가상의 영업장 또는
        &quot;회사&quot;가 운영하는 아래의 웹사이트를 말합니다.
        <br />
        가.{' '}
        <a
          href='https://www.ko-ready.com/'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          https://www.ko-ready.com/
        </a>
      </>,
      ``,
      `2. "서비스"란 "회사"가 "사이트"를 통하여 제공하는 다음의 서비스 및 이에 부수하거나 제휴를 통해 제공되는 모든 서비스를 통칭합니다.`,
      `· 기업(법인·단체·개인사업자·공공기관 등을 포함하며, 이하 같습니다)이 직원 채용 또는 인력 모집을 목적으로 "사이트"에 등록한 자료를 데이터베이스로 구축하고, 목적에 맞게 분류·가공·집계하여 정보로 제공하는 서비스`,
      `· 개인이 "회원"의 채용공고에 지원하면서 제출한 자료를 해당 "회원"에게 제공하는 서비스`,
      `· 기업에 관한 자료를 수집·분류·가공하여 정보로 제공하는 서비스`,
      ``,
      `3. "회원"이란 자사의 직접 고용을 목적으로 채용을 원하는 제2호의 기업으로서, 이 약관에 동의하고 "회사"와 이용계약을 체결한 기업회원을 말합니다.`,
      ``,
      `4. "서비스 이용계약"이란 "회원"이 "회사"가 제공하는 서비스를 계속하여 이용하기 위하여 "회사"와 체결하는 계약을 말합니다.`,
      ``,
      `5. "아이디(ID)"란 "회원"의 식별과 서비스 이용을 위하여 "회원"이 가입 시 등록한 이메일 주소를 말합니다.`,
      ``,
      `6. "비밀번호"란 "회원"이 아이디를 부여받은 자와 동일인임을 확인하고 "회원"의 권익을 보호하기 위하여 "회원"이 정한 문자와 숫자의 조합, 또는 같은 용도로 "사이트"에서 자동 생성되는 인증코드를 말합니다.`,
      ``,
      `7. "채용공고"란 구인을 위하여 "회원"과 "회사"가 제공하는 포지션 등 구인·구직 정보 일체를 말합니다.`,
      ``,
      `8. "유료서비스"란 "서비스" 중 "회사"가 유료로 제공하는 각종 부가 서비스를 말합니다.`,
      ``,
      `9. "게시물"이란 "회원"이 서비스를 이용하면서 서비스상에 게시한 글, 사진, 동영상, 각종 파일 및 링크 등 정보 형태의 자료를 말합니다.`,
      ``,
      `10. "결제"란 "회원"이 "유료서비스"를 이용하기 위하여 "회사"가 지정한 결제수단으로 일정 금액을 지급하는 것을 말합니다.`,
      ``,
      `11. "개인회원"이란 코레디 개인회원 이용약관에 동의하고 "회사"와 이용계약을 체결한 자로서, 구직 또는 채용 지원을 목적으로 서비스를 이용하는 개인을 말합니다. 개인회원 이용약관에서 "이용자" 또는 "회원"으로 표기된 자와 같은 대상을 가리킵니다.`,
      ``,
      `12. "제출 서류"란 개인회원이 "회원"의 채용공고에 지원하면서 제출한 이력서 및 그 밖의 채용 관련 서류를 말합니다.`,
    ],
  },
  {
    heading: '제3조 (약관의 명시와 개정)',
    body: [
      `① "회사"는 이 약관의 내용과 상호, 영업소 소재지, 대표자 성명, 사업자등록번호, 연락처 등을 "회원"이 확인할 수 있도록 초기 화면에 게시하거나 그 밖의 방법으로 안내합니다.`,
      ``,
      `② "회사"는 「약관의 규제에 관한 법률」, 「전기통신기본법」, 「전기통신사업법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령에 위배되지 않는 범위에서 이 약관을 개정할 수 있습니다.`,
      ``,
      `③ "회사"가 약관을 개정하는 경우에는 적용일자와 개정 사유를 밝혀 현행 약관과 함께 적용일 7일 전부터 적용일 전날까지 공지합니다. 다만 "회원"의 권리나 의무에 중대한 영향을 미치는 변경의 경우에는 적용일 30일 전부터 공지합니다.`,
      ``,
      `④ "회원"은 개정 약관에 동의하지 않을 권리가 있으며, 개정 약관이 공지된 날부터 15일 이내에 거부 의사를 표시할 수 있습니다. "회원"이 거부 의사를 표시한 경우 "회사"는 15일의 기간을 정하여 사전 통지한 후 해당 "회원"과의 계약을 해지할 수 있습니다. "회원"이 거부 의사를 표시하지 않거나 적용일 이후에도 서비스를 계속 이용하는 경우에는 개정 약관에 동의한 것으로 봅니다.`,
      ``,
      `⑤ "회사"는 "회원"이 가입 시 등록하고 수신에 동의한 이메일 또는 휴대전화 문자메시지 등의 수단으로 각종 고지와 통지를 할 수 있습니다. 다만 서비스 이용에 관한 안내가 필요한 경우에는 수신에 동의한 수단 외의 방법으로도 통지할 수 있습니다.`,
    ],
  },
  {
    heading: '제4조 (약관의 해석)',
    body: [
      `① 이 약관에서 정하지 않은 사항은 「약관의 규제에 관한 법률」, 「전기통신기본법」, 「전기통신사업법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령과 상관례에 따릅니다.`,
      ``,
      `② "회원"이 "회사"와 개별 계약을 체결하여 서비스를 이용하는 경우에는 그 개별 계약이 이 약관에 우선합니다.`,
    ],
  },
  {
    heading: '제5조 (서비스 이용계약의 성립)',
    body: [
      `① 서비스를 이용하려는 자가 이 약관과 개인정보처리방침을 확인한 후 "동의" 또는 "확인" 버튼을 누른 경우, 이 약관에 동의하고 회원가입을 신청한 것으로 봅니다.`,
      ``,
      `② "회사"는 제1항의 신청과 관련하여 기업 인증을 위하여 법인 또는 사업자의 명칭, 담당자 성명, 연락처 등의 제공을 요청할 수 있으며, 사업자등록증 등 사업자 정보를 확인할 수 있는 증명서를 별도로 요구할 수 있습니다.`,
      ``,
      `③ 제1항의 신청을 한 자(이하 "이용신청자")에게 "회사"가 서비스 내 안내 또는 이메일로 계약 체결 사실을 통지하고, "회사"와 이용신청자 사이에 계약이 체결됨으로써 "서비스 이용계약"이 성립합니다.`,
      ``,
      `④ 사업자등록번호가 없는 기관이나 단체는 "회사"가 정한 별도의 절차에 따라 이용계약을 체결할 수 있습니다.`,
    ],
  },
  {
    heading: '제6조 (이용신청의 승낙과 제한)',
    body: [
      `① "회사"는 제5조에 따른 이용신청에 대하여 원칙적으로 접수 순서에 따라 서비스 이용을 승낙합니다.`,
      ``,
      `② "회사"는 다음 각 호에 해당하는 경우에는 이용을 승낙하지 않습니다.`,
      `가. "회원"이 허위의 정보를 제공하여 신청한 경우`,
      `나. "회원"이 이용계약 신청 내용을 허위로 기재하거나 "회사"가 요구하는 사항을 기재하지 않은 경우`,
      `다. "회원"의 귀책사유로 승인이 불가능하거나, 법령 또는 "회사"의 제반 규정을 위반하여 신청한 경우`,
      `라. "회사"가 정한 회원가입 신청 요건을 충족하지 못하는 경우`,
      ``,
      `③ "회사"는 다음 각 호에 해당하는 경우 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.`,
      `가. "회사"의 설비에 여유가 없는 경우`,
      `나. "회사"에 기술상 지장이 있는 경우`,
      `다. 그 밖에 서비스 운영상 합리적인 사유로 승낙이 곤란한 경우`,
    ],
  },
  {
    heading: '제7조 (서비스의 내용)',
    body: [
      `① "회사"는 제2조 제2호의 서비스를 제공하며, 그 내용은 다음 각 호와 같습니다.`,
      `가. 채용 포지션 등록 서비스`,
      `나. 온라인 채용관리 서비스`,
      `다. 구직자 소개 및 채용 컨설팅 서비스`,
      `라. 구인·구직과 관련된 제반 서비스`,
      `마. 지원자 관리 및 제출 서류 열람 서비스`,
      `바. 이용자 사이의 교류와 소통에 관한 서비스`,
      `사. 자료 거래에 관한 서비스`,
      `아. 그 밖에 "회사"가 추가로 개발하거나 제휴계약 등을 통하여 "회원"에게 제공하는 일체의 서비스`,
      ``,
      `② "회사"는 필요한 경우 서비스의 내용을 추가하거나 변경할 수 있으며, 이 경우 그 내용을 "회원"에게 공지합니다.`,
      ``,
      `③ "회사"는 "회원" 또는 개인회원이 "사이트"에 등록하거나 제공한 정보를 관련 법령에 따른 조치(가명처리·비식별처리 등)를 거쳐 통계자료로 만들거나 데이터베이스로 구축하여 활용할 수 있습니다.`,
    ],
  },
  {
    heading: '제8조 (채용공고 등록 및 지원자 서류의 취급)',
    body: [
      `① "회원"은 구직을 원하는 개인회원이 채용공고를 열람한 후 해당 기업을 판단할 수 있도록 자사에 관한 정보를 정확하게 기재하여야 합니다.`,
      ``,
      `② "회원"은 「직업안정법」 제34조 및 같은 법 시행령 제34조에서 정한 거짓 구인광고에 해당하지 않도록 채용공고를 작성하여야 하며, 다음 각 호의 내용은 등록할 수 없습니다.`,
      `가. 구인을 가장하여 물품 판매, 수강생 모집, 직업소개, 부업 알선, 자금 모집 등을 하는 광고`,
      `나. 거짓 구인을 목적으로 구인자의 신원(업체명 또는 성명)을 표시하지 않는 광고`,
      `다. 구인자가 제시한 직종, 고용형태, 근로조건 등이 실제 응모 시의 조건과 현저히 다른 광고`,
      `라. 그 밖에 광고의 중요한 내용이 사실과 다른 광고`,
      ``,
      `③ "회원"은 관련 법령에 따라 채용 또는 인력 모집의 전 과정에서 성별, 연령, 국적 등을 이유로 구직자를 차별하여서는 안 되며, 15세 미만인 자를 채용하거나 모집할 수 없습니다.`,
      ``,
      `④ 제2항과 제3항을 위반한 경우 그에 대한 책임은 전적으로 "회원"에게 있습니다.`,
      ``,
      `⑤ "회사"는 "회원"이 등록한 기업정보와 채용공고를 "회사"가 정한 방법으로 노출할 수 있습니다.`,
      ``,
      `⑥ "회원"은 개인회원이 "회원"의 채용공고에 지원하면서 제출한 서류를 열람할 수 있으며, "회사"가 제공하는 커뮤니케이션 수단을 통하여 해당 개인회원에게 채용 절차와 관련한 연락을 할 수 있습니다. "회사"는 개인회원의 지원 없이 "회원"이 개인회원의 이력서를 검색하거나 열람할 수 있는 기능을 제공하지 않습니다. 개인회원의 제출 서류 열람, 연락 또는 면접의 목적은 채용 또는 인력 모집에 한정되어야 하며, "회원"이 이를 영업·마케팅 목적으로 활용하거나 제3자에게 제공하는 경우 「개인정보 보호법」, 「직업안정법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령에 따른 법적 책임을 부담합니다.`,
      ``,
      `⑦ "회원"이 제2조 제3호에 따른 직접 고용을 목적으로 하지 않고 헤드헌팅, 아웃소싱(도급), 인재파견, 채용대행 등 인력의 소개 또는 관련 계약의 중개를 목적으로 채용공고를 등록하는 경우, "회사"는 해당 공고를 삭제할 수 있습니다.`,
      ``,
      `⑧ 개인회원의 지원을 통하여 제공받은 제출 서류에 대한 "회원"의 열람 권한은 다음 각 호의 기준에 따라 종료되며, "회사"는 해당 시점에 열람 권한을 자동으로 만료처리합니다.`,
      `1. 해당 개인회원을 최종 합격자로 결정한 경우: 공식 입사일부터 최대 90일이 되는 날`,
      `2. 해당 개인회원이 불합격한 경우: 해당 채용 절차가 종료된 즉시`,
      ``,
      `⑨ 개인회원이 지원을 철회하거나 서류의 제출·공유에 대한 동의를 철회한 사실을 "회사"가 통지한 경우, "회원"은 지체 없이 해당 개인회원의 제출 서류의 이용을 중단하고 이를 파기하여야 합니다.`,
      ``,
      `⑩ "회원"은 제8항과 제9항에 따라 열람 권한이 종료된 제출 서류를 자사의 시스템·문서 등에서 지체 없이 파기하여야 하며, "회사"의 요청이 있는 경우 파기 사실을 확인하여야 합니다. 다만 「채용절차의 공정화에 관한 법률」 등 관련 법령에 따라 보관이 필요한 경우에는 해당 법령에서 정한 기간 동안 보관하고, 그 기간이 지나면 지체 없이 파기합니다.`,
      ``,
      `⑪ 제8항부터 제10항까지의 기준은 개인회원 이용약관 제12조의4에 따라 개인회원에게 고지된 사항이며, "회원"은 이를 준수하여야 합니다. "회원"이 이를 위반하는 경우 "회사"는 제18조에 따라 이용 제한 등 필요한 조치를 취할 수 있습니다.`,
    ],
  },
  {
    heading: '제9조 (제휴를 통한 서비스)',
    body: [
      `① "회사"는 제휴 관계를 맺은 인터넷 웹사이트, 채용박람회, 신문·잡지 등 오프라인 매체를 통하여 "회원"이 "사이트"에 등록한 기업정보와 채용공고가 열람될 수 있도록 서비스를 제공할 수 있습니다.`,
      ``,
      `② "회사"는 제휴를 통하여 다른 사이트나 매체에 등록될 수 있음을 안내하여야 하며, 제휴 사이트 목록을 "사이트" 내에서 상시 확인할 수 있도록 합니다. 다만 "회사"가 직접 구축하지 않고 제휴사가 XML 또는 API 형태로 자료를 제공받아 구축한 매체의 목록은 이 약관과 별도의 제휴 목록에서 확인할 수 있도록 합니다.`,
    ],
  },
  {
    heading: '제10조 (서비스의 요금)',
    body: [
      `① "회원" 가입과 채용공고 등록 비용은 원칙적으로 무료로 제공되나, "회원" 또는 사이트에 방문한 자에게 관련 정보를 보다 효과적으로 노출시키거나, 정기권 구독 등과 같은 유료 옵션 서비스 및 기타 제반 기능을 이용하기 위한 서비스는 유료로 제공할 수 있습니다.`,
      ``,
      `② "회사"는 "유료서비스"를 제공하는 경우 그 요금을 "사이트"에 공지합니다. 다만 "회사"가 "회원"과 개별 계약을 체결하여 "유료서비스"를 제공하는 경우에는 그러하지 않습니다.`,
      ``,
      `③ "회사"는 "유료서비스"의 이용금액을 서비스의 종류와 기간에 따라 예고 없이 변경할 수 있습니다. 다만 변경 전에 이미 적용되었거나 계약된 금액에는 소급하여 적용하지 않습니다.`,
      ``,
      `④ "유료서비스" 신청 후 "회원"의 사정으로 서비스가 취소되는 경우, "회사"는 「콘텐츠 이용자 보호지침」 등 관련 기준에 따라 "회원"에게 환불 수수료를 부과할 수 있습니다.`,
    ],
  },
  {
    heading: '제11조 (서비스 이용시간)',
    body: [
      `① "회사"는 특별한 사유가 없는 한 연중무휴 1일 24시간 서비스를 제공합니다. 다만 서비스의 종류나 성질에 따라 일부 서비스에 대해서는 별도의 이용시간을 정할 수 있으며, 이 경우 "회사"는 그 이용시간을 사전에 게시하거나 "회원"에게 공지합니다.`,
      ``,
      `② "회사"는 자료의 가공·갱신을 위한 시스템 작업, 장애 해결을 위한 보수작업, 정기 점검, 시스템 교체, 회선 장애 등이 발생한 경우 일시적으로 서비스를 중단할 수 있습니다. 계획된 작업의 경우에는 공지사항 게시 등 적절한 방법으로 중단 시간과 작업 내용을 알리며, 사전에 통지할 수 없는 부득이한 사유가 있는 경우에는 사후에 통지할 수 있습니다.`,
    ],
  },
  {
    heading: '제12조 (서비스 제공의 중지)',
    body: [
      `① "회사"는 다음 각 호에 해당하는 경우 서비스의 제공을 중지할 수 있습니다.`,
      `가. 설비의 보수 등 "회사"의 필요에 따라 사전에 "회원"에게 통지한 경우`,
      `나. 기간통신사업자가 전기통신서비스의 제공을 중지한 경우`,
      `다. 그 밖에 불가항력적인 사유로 서비스 제공이 객관적으로 불가능한 경우`,
      ``,
      `② 제1항의 경우 "회사"는 기간이 정해진 "유료서비스"를 이용 중인 "회원"에게 그 이용기간을 연장하는 등의 방법으로 손실을 보상합니다.`,
    ],
  },
  {
    heading: '제13조 (정보의 제공 및 광고의 게재)',
    body: [
      `① "회사"는 서비스 이용에 필요하다고 인정되거나 서비스 개선 및 서비스 소개 등을 목적으로 하는 각종 정보를 이메일, 서면 우편, 앱 푸시 알림, 모바일 기기 등을 이용한 방법으로 "회원"에게 제공할 수 있습니다.`,
      ``,
      `② "회사"는 제공하는 서비스와 관련된 정보 또는 광고를 서비스 화면, 홈페이지, 이메일 등에 게재할 수 있으며, 광고가 게재된 이메일을 받은 "회원"은 "회사"에 수신 거부를 요청할 수 있습니다.`,
      ``,
      `③ "회사"는 서비스에 게재된 광고 또는 서비스를 통한 광고주의 판촉활동에 "회원"이 참여하거나 교신·거래함으로써 발생하는 손실과 손해에 대하여 책임지지 않습니다.`,
      ``,
      `④ "회원"은 서비스 이용 시 노출되는 광고의 게재에 동의한 것으로 봅니다.`,
    ],
  },
  {
    heading: '제14조 (자료에 관한 책임과 "회사"의 정보 수정 권한)',
    body: [
      `① "회원"은 서비스 내 또는 "사이트"에 작성·게시하는 기업정보, 채용공고, 자료, 게시물 등을 사실에 근거하여 정확하게 작성하여야 하며, 그 내용이 허위이거나 부정확하여 발생하는 모든 책임은 "회원"에게 있습니다.`,
      ``,
      `② "회원"이 제1항의 게시물 등을 제3자에게 위탁하거나 대행하게 하는 경우에도 그에 관한 책임은 "회원"에게 있으며, "회원"은 게시물 등을 주기적으로 확인하고 관리하여야 합니다.`,
      ``,
      `③ "회사"는 제1항의 게시물 등에 오탈자가 있거나 법령 또는 사회적 통념에 어긋나는 문구와 내용이 있는 경우 이를 언제든지 수정하거나 삭제할 수 있습니다.`,
    ],
  },
  {
    heading: '제15조 (자료 내용의 활용 및 취급)',
    body: [
      `① "회원"이 서비스 내 또는 "사이트"에 입력·작성·업로드한 정보 등은 채용 및 그 밖의 HR 관련 통계자료로 활용될 수 있으며, "회사"는 관련 법령을 준수하는 범위에서 이를 개인회원에게 제공하거나 매체를 통하여 언론에 배포할 수 있습니다.`,
      ``,
      `② "회원"은 지원 등 정당한 절차를 거쳐 열람한 개인회원의 이력서 등 정보를 "서비스 이용계약" 체결 목적으로만 사용할 수 있으며, 그중 개인정보는 관련 법령에 따라 보호하여야 합니다.`,
      ``,
      `③ "회사"는 "사이트"의 온라인 입사지원 시스템을 통하여 지원한 개인회원에게 "회원"이 해당 이력서를 열람하였는지 여부를 통지할 수 있습니다.`,
    ],
  },
  {
    heading: '제16조 ("회사"의 의무)',
    body: [
      `① "회사"는 이 약관에서 정한 바에 따라 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다합니다.`,
      ``,
      `② "회사"는 서비스와 관련한 "회원"의 불만사항이 접수되는 경우 신속하게 처리하며, 즉시 처리가 곤란한 경우에는 그 사유와 처리 일정을 서비스 화면 또는 그 밖의 방법으로 해당 "회원"에게 통지합니다.`,
      ``,
      `③ "회사"는 "회원"의 유료 결제와 관련한 결제 정보를 1년 이상 보존합니다.`,
      ``,
      `④ 천재지변 등 예측할 수 없는 사유나 시스템 장애로 서비스가 중단된 경우 그로 인한 손해에 대하여 "회사"는 책임을 지지 않습니다. 다만 자료의 복구와 정상적인 서비스 지원을 위하여 최선을 다할 의무를 부담합니다.`,
      ``,
      `⑤ "회사"는 "회원"의 자료를 서비스 제공 목적 외로 제3자에게 제공하거나 열람하게 하는 경우 반드시 "회원"의 동의를 받습니다.`,
      ``,
      `⑥ "회원"이 "사이트"에 등록한 기업정보와 채용공고 등의 내용은 "사이트"를 방문하는 일반 대중에게 공개함을 원칙으로 합니다.`,
      ``,
      `⑦ "회사"는 일정 기간 이상 서비스를 이용하지 않는 "회원"에 대하여 서비스 내 관리 권한을 제한하는 등 필요한 조치를 취합니다.`,
    ],
  },
  {
    heading: '제17조 ("회원"의 의무)',
    body: [
      `① "회원"은 관련 법령, 이 약관의 규정 및 "회사"가 통지하는 사항을 준수하여야 하며, "회사"의 업무를 방해하는 행위를 해서는 안 됩니다.`,
      ``,
      `② "회원"이 신청한 "유료서비스"는 그 등록 또는 신청과 동시에 "회사"와 "회원" 사이에 채권·채무 관계가 발생하며, "회원"은 수수료와 요금 등 대가를 지정된 기일 내에 납부하여야 합니다.`,
      ``,
      `③ "회원"이 결제수단으로 신용카드를 사용하는 경우 비밀번호 등 정보의 유실 방지는 "회원"이 스스로 관리하여야 합니다. 다만 "사이트"의 결함으로 발생한 정보 유실에 대해서는 그러하지 않습니다.`,
      ``,
      `④ "회원"은 서비스를 이용하여 얻은 정보를 "회사"의 사전 동의 없이 복사, 복제, 번역, 출판, 방송 등의 방법으로 사용하거나 타인에게 제공할 수 없습니다.`,
      ``,
      `⑤ "회원"은 "서비스 이용계약"을 체결한 목적 또는 이를 이행하기 위한 목적 외로 서비스를 사용해서는 안 되며, 이용 중 다음 각 호의 행위를 해서는 안 됩니다.`,
      `가. 다른 회원의 아이디를 부정하게 사용하는 행위`,
      `나. 범죄행위를 목적으로 하거나 범죄행위와 관련된 행위`,
      `다. 타인의 명예를 훼손하거나 모욕하는 행위`,
      `라. 타인의 지식재산권 등 권리를 침해하는 행위`,
      `마. 해킹 또는 바이러스를 유포하는 행위`,
      `바. 타인의 의사에 반하여 광고성 정보 등을 계속 전송하는 행위`,
      `사. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있다고 판단되는 행위`,
      `아. "사이트"의 정보와 서비스를 이용한 영리 행위`,
      `자. 그 밖에 선량한 풍속과 사회질서를 해치거나 관련 법령을 위반하는 행위`,
      ``,
      `⑥ "회원"은 "사이트"를 통하여 열람한 이력서, 게시물 등 정보(개인정보를 포함합니다)를 "회사" 및 해당 개인의 사전 서면 허락 없이 서비스 목적 외로 사용하거나 제3자에게 제공할 수 없으며 이를 비밀로 유지하여야 합니다. "회원"은 그 임직원 또는 서비스 내 관리 권한을 부여받은 자에게도 같은 비밀유지의무를 부담하게 하여야 합니다.`,
      ``,
      `⑦ "회사"는 자동화된 수단을 활용하는 등 서비스의 기능을 비정상적으로 이용하여 게재된 게시물이나 개별 서비스의 제공 취지에 부합하지 않는 게시물을 삭제하는 등의 방법으로 제한할 수 있습니다.`,
      ``,
      `⑧ "회원"은 "회사"의 사전 허락 없이 자동화된 수단(매크로 프로그램, 봇, 스파이더, 스크래퍼 등)을 이용하여 회원가입 또는 로그인을 시도하거나, 게시물을 게재하거나, 다른 회원의 아이디·게시물 등을 수집해서는 안 됩니다. 또한 서비스의 제공 취지에 부합하지 않는 남용 행위를 막기 위한 "회사"의 기술적 조치를 무력화하는 일체의 행위(접속 IP를 계속 변경하는 행위, 캡차를 우회하거나 무력화하는 행위 등)를 시도해서는 안 됩니다.`,
      ``,
      `⑨ "회원"은 "회사"의 동의 없이 자동화된 수단으로 서비스의 광고 게재 영역 또는 그 밖의 영역에 문자, 음성, 이미지, 동영상, 링크 등으로 구성된 콘텐츠나 파일을 삽입해서는 안 됩니다. "회원"은 서비스 또는 이에 포함된 소프트웨어를 복사·수정할 수 없으며, 이를 판매, 양도, 대여하거나 담보로 제공하거나 타인에게 이용을 허락할 수 없습니다. 서비스에 포함된 소프트웨어를 역설계하거나 소스코드 추출을 시도하는 행위, 복제·분해·모방하거나 변형하는 행위도 금지됩니다. 다만 오픈소스에 해당하는 경우에는 해당 라이선스 조건에 따릅니다. 그 밖에 "회원"은 바이러스나 악성코드를 업로드하거나 서비스의 원활한 운영을 방해할 목적으로 서비스 기능을 비정상적으로 이용해서는 안 됩니다.`,
    ],
  },
  {
    heading: '제18조 (서비스 제공 중지 등)',
    body: [
      `"회사"는 다음 각 호의 사유가 발생하거나 "회원"에게 해당 사유가 있는 경우 사전 통지 없이 "서비스 이용계약"의 해지, 서비스 제공 중지 또는 채용공고 삭제 등의 조치를 취할 수 있습니다.`,
      ``,
      `1. "회원"이 이 약관을 위반하거나 "회원"의 의무를 성실히 이행하지 않은 경우`,
      `2. "회원"이 "유료서비스" 이용요금을 납부하지 않은 경우`,
      `3. "회원"이 부당한 의도로 "유료서비스"의 결제와 취소를 반복하는 경우`,
      `4. 서비스의 목적에 맞지 않는 분야에 정보를 활용하여 사회적 물의가 발생한 경우`,
      `5. "회원"이 등록한 정보의 내용이 사실과 다르거나 조작된 경우`,
      `6. 같은 아이디 또는 같은 사업자가 마감일이 지나지 않은 사실상 동일한 내용의 채용공고를 중복하여 등록한 경우`,
      `7. 다음 각 목에 해당하는 채용공고 또는 인력 모집 공고를 등록한 경우`,
      `가. 허위 구인공고`,
      `나. 제시된 직종, 업무내용, 근로조건 등이 실제와 현저히 다른 공고`,
      `다. 모집요강만으로는 업무 내용이 명확하지 않은 공고`,
      `라. 모집요강에 적합한 업·직종 분류를 지정하지 않은 공고(예: 교육기관이 영업·마케팅·텔레마케팅·상담 인력을 모집하는 경우 실제 업무와 직접 관련된 업·직종 분류를 지정하여야 합니다)`,
      `마. 다단계 또는 피라미드 방식의 모집 내용을 포함한 공고`,
      `바. 구인을 가장하여 유학 알선, 물품 판매, 자금 모금 등을 하는 공고`,
      `사. 회원 모집 형태의 광고 또는 카드회원 모집(수당제 광고) 공고`,
      `아. 추천인 모집 광고, 재택 쇼핑몰 분양 광고, 직업소개 또는 부업 알선 광고`,
      `자. 취업수수료 등 취업 관련 비용을 요구하는 공고(운송, 물류, 지입, 인력용역 등)`,
      `차. 불건전한 내용의 유흥업소 채용공고`,
      `카. 동업자 모집, 프랜차이즈 모집, 점포 개설, 창업, 사이트 홍보 등 직원 채용이 아닌 공고`,
      `8. 채용공고와 관련하여 구직자의 피해 사례가 접수된 경우(채용공고를 통한 입사 과정에서 피해가 발생한 경우, 재직 중 "회원"이 관련 법령을 위반하여 피해가 발생한 경우 등)`,
      `9. "회원"이 헤드헌팅, 아웃소싱(도급), 인재파견, 채용대행 등 인력 중개를 주된 목적으로 사업을 수행하는 업체에 해당하는 경우`,
      `10. 임금체불로 근로감독기관에 진정이 접수되었거나 관계 당국에 고소·고발된 기업인 경우(다만 임금체불이 해소되었음이 확인되면 서비스를 다시 이용할 수 있습니다)`,
      `11. 서비스의 명예를 훼손한 경우`,
      `12. "회원"이 개인회원의 이력서 또는 제출 서류를 채용 또는 인력 모집 외의 목적으로 이용하거나 제3자에게 제공한 경우`,
      `13. "회원"이 제8조 제8항부터 제10항까지에서 정한 열람 권한이 종료된 후에도 이력서 또는 제출 서류를 계속 보유하거나 "회사"의 파기 확인 요청에 응하지 않은 경우`,
      `14. 그 밖에 관련 법령을 위반하거나 "사이트"의 원활한 운영을 위하여 "회사"가 필요하다고 판단한 경우`,
    ],
  },
  {
    heading: '제19조 (가입 해지 / 서비스 중지 / 자료 삭제)',
    body: [
      `① "회원"은 언제든지 고객센터 또는 회원 탈퇴 메뉴 등을 통하여 회원 탈퇴 또는 채용공고 등록 해지를 신청할 수 있으며, "회사"는 관련 법령에서 정하는 바에 따라 이를 처리합니다.`,
      ``,
      `② "회원"이 "유료서비스"를 이용하는 중 "회사"의 책임으로 정상적인 서비스가 제공되지 않는 경우 "회원"은 해지를 요청할 수 있습니다. 이 경우 "회사"는 기간이 정해진 "유료서비스"에 대해서는 해지일까지의 이용일수를 1일 기준금액으로 계산하여 공제한 후 환급하고, 이용 건수가 정해진 "유료서비스"에 대해서는 이미 사용한 분을 1건 기준금액으로 계산하여 공제한 후 환급합니다. 다만 허위 또는 불량 공고의 경우 게재 시 지급된 광고료는 반환하지 않습니다.`,
      ``,
      `③ "회사"는 회원 가입이 해지된 경우 해당 회원의 정보를 모두 삭제합니다. 다만 「상법」, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령에 따라 보존할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 회원정보를 보관합니다.`,
    ],
  },
  {
    heading: '제20조 (허위 구인광고에 대한 경고)',
    body: [
      `허위 구인광고로 발생한 문제에 대한 법적 책임은 전적으로 작성자에게 있으며, 구인광고 게재 시 지급된 광고료는 반환하지 않습니다. 허위 구인광고를 게시하거나 거짓 구인조건을 제시한 자는 「직업안정법」에 따라 5년 이하의 징역 또는 2천만원 이하의 벌금에 처해질 수 있습니다.`,
    ],
  },
  {
    heading: '제21조 (손해배상)',
    body: [
      `① "회사"가 이 약관 제7조, 제16조 등의 규정을 위반한 행위로 "회원"에게 손해를 입히거나, "회사"가 제공하는 서비스와 관련하여 "회사"의 책임 있는 사유로 "회원"에게 손해가 발생한 경우 "회사"는 그 손해를 배상합니다.`,
      ``,
      `② "회사"의 책임 있는 사유로 제공한 정보가 사실과 달라 "회원"이 손해를 입은 경우 "회사"는 그 손해를 배상합니다.`,
      ``,
      `③ "회원"이 이 약관 제5조, 제8조, 제17조, 제18조, 제19조, 제20조 등의 규정을 위반한 행위로 "회사" 또는 제3자에게 손해를 입히거나, "회원"의 책임 있는 사유로 "회사" 또는 제3자에게 손해가 발생한 경우 "회원"은 그 손해를 배상하여야 합니다.`,
      ``,
      `④ 다른 회원(개인회원과 기업회원을 모두 포함합니다)의 귀책사유로 "회원"에게 손해가 발생한 경우 "회사"는 이에 대한 배상 책임을 지지 않습니다.`,
    ],
  },
  {
    heading: '제22조 (이용요금 오류의 조정)',
    body: [
      `"회사"는 이용요금에 오류가 있는 경우 "회원"의 요청 또는 "회사"의 사전 통지에 따라 다음 각 호의 조치를 취합니다.`,
      ``,
      `1. 과다하게 납입된 요금은 반환합니다. 다만 "회원"이 동의하는 경우 다음 달 청구 요금에서 해당 금액을 차감하여 청구합니다.`,
      `2. 요금을 반환받아야 할 "회원"에게 체납된 요금이 있는 경우에는 반환할 요금에서 이를 우선 공제한 후 반환합니다.`,
      `3. 과소 청구된 금액은 다음 달에 합산하여 청구합니다.`,
    ],
  },
  {
    heading: '제23조 (이용요금의 과오납·과소 청구와 정산)',
    body: [
      `"회원"이 지급한 이용요금에 과오납 등의 사유가 있는 경우 "회사"는 다음 각 호의 조치를 취합니다. 다만 "회사"와 "회원" 사이에 별도로 체결된 계약이 있는 경우에는 그 계약 조건을 우선합니다.`,
      ``,
      `1. 과다 납입된 이용요금은 환급하며, "회원"이 동의하는 경우 다음 달 청구될 이용요금에서 해당 금액을 차감하여 청구합니다.`,
      `2. 이용요금을 환급받아야 할 "회원"에게 체납된 이용요금이 있는 경우, 환급할 금액에서 체납액을 우선 공제한 후 남은 금액을 반환합니다.`,
      `3. 이용요금을 과소 청구한 경우 "회사"는 그 금액을 다음 달 이용요금과 합산하여 청구하며, 다음 달 청구할 이용요금이 없는 경우에는 과소 청구 사실을 확인한 즉시 청구합니다.`,
    ],
  },
  {
    heading: '제24조 (이용요금의 환불 및 보상)',
    body: [
      `"회사"는 다음 각 호에 해당하는 경우 이용요금을 환불하거나 보상하며, 이는 유료로 서비스를 제공한 경우에만 적용됩니다. 유료 광고상품이나 서비스를 정상적으로 이용할 수 있었던 기간이 있는 경우에는 그 기간에 상응하는 이용금액을 공제한 나머지 금액을 환불하거나 보상합니다. 구체적인 처리는 상호 협의를 통하여 진행하며, 환불을 원하는 "회원"은 환불 사유를 밝힌 서면으로 "회사"에 요청하여야 합니다.`,
      ``,
      `1. 유료 광고 또는 서비스의 이용이 시작되지 않은 경우`,
      `2. "회사"의 시스템 또는 네트워크 장애로 서비스를 이용할 수 없는 경우`,
      `3. "회사"의 귀책사유로 유료서비스의 이용이 어려운 경우`,
      `4. 그 밖에 판매약관에서 정한 경우`,
    ],
  },
  {
    heading: '제25조 ("회원"의 개인정보 보호)',
    body: [
      `"회사"는 "회원"의 개인정보를 보호하기 위하여 노력하며, 개인정보의 처리에 관한 사항은 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보 보호법」 등 관련 법령과 "회사"가 "사이트"에 게시하는 개인정보처리방침에 따릅니다.`,
    ],
  },
  {
    heading: '제26조 (신용정보의 제공·활용 동의)',
    body: [
      `① "회사"가 회원가입과 관련하여 취득한 "회원"의 신용정보를 타인에게 제공하거나 활용하려는 경우에는 「신용정보의 이용 및 보호에 관한 법률」 제23조에 따라 사전에 그 사유와 해당 기관 또는 업체명 등을 밝히고 해당 "회원"의 동의를 받아야 합니다.`,
      ``,
      `② 서비스와 관련하여 "회사"가 "회원"으로부터 「신용정보의 이용 및 보호에 관한 법률」에 따라 신용정보의 제3자 제공에 대한 동의를 받은 경우, "회사"는 신용정보사업자 또는 신용정보집중기관에 해당 신용정보를 제공하여 "회원"의 신용을 판단하기 위한 자료로 활용하게 하거나, 공공기관에서 정책자료로 활용되도록 제공할 수 있습니다.`,
    ],
  },
  {
    heading: '제27조 (통합회원제)',
    body: [
      `① "회원"은 통합된 하나의 계정(아이디 및 비밀번호)으로 제2조 제1호에 명시된 "사이트"와 관련 서비스를 이용할 수 있습니다.`,
      ``,
      `② "회사"는 하나의 계정을 통한 통합 서비스 제공을 위하여 각 사이트 간 서비스 내용을 연동하는 등 사이트 또는 서비스를 개선하거나 변경할 수 있습니다.`,
      ``,
      `③ "회원"이 최초로 서비스 이용계약을 체결한 이후 "회사"의 사이트가 추가되는 경우, 별도의 약관으로 정하지 않는 한 이 약관이 적용됩니다. "회사"는 신규 사이트 또는 서비스의 개시에 관한 정보를 "사이트"에 공지하거나 "회원"에게 이메일로 안내할 수 있습니다.`,
    ],
  },
  {
    heading: '제28조 (분쟁의 해결)',
    body: [
      `① "회사"와 "회원"은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 다합니다.`,
      ``,
      `② 제1항의 노력에도 불구하고 분쟁이 해결되지 않는 경우, 해당 분쟁의 해결은 "회사"의 주소지를 관할하는 법원을 전속 관할로 합니다.`,
    ],
  },
  {
    chapter: '부칙',
    heading: '시행일 및 사업자 정보',
    body: [
      `① 이 약관은 2026년 08월 28일부터 시행합니다.`,
      ``,
      `사업자 정보`,
      `· 상호: 오잉랩 (Oing Lab)`,
      `· 브랜드명: 코레디 (Koready)`,
      `· 대표자: 권하연`,
      `· 주소: 경기도 수원시 광교호수공원로 277번길`,
      `· 사업자등록번호: 179-45-01005`,
      `· 통신판매업신고번호: 2025-수원영통-1407`,
      `· 직업정보제공사업 신고번호: J180020260001`,
      `· 개인정보 보호책임자: 권하연`,
      <>
        · 제휴 문의:{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>
      </>,
      `· 고객지원(CS): 010-3009-2993`,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: '기업회원 이용약관',
  lastUpdated: '2026년 8월 28일',
  lastUpdatedLabel: '시행일',
  effectiveDate: '2026-08-28',
  sections,
};
